import React, { useId } from 'react';

import { InputControl } from '../components/InputControl';
import { MultiselectProps } from './types';
import { RawMultiSelect } from './RawMultiSelect';

function Multiselect({
  error,
  helpText,
  label,
  condensed,
  ...props
}: MultiselectProps) {
  const labelId = useId();
  return (
    <InputControl
      condensed={condensed}
      error={error}
      helpText={helpText}
      label={label}
      labelId={labelId}
    >
      <RawMultiSelect {...props} labelId={label ? labelId : undefined} />
    </InputControl>
  );
}
export { Multiselect };
